var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoodleGroupWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 612,
    height: 43,
    viewBox: "0 0 612 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8974 5.58447H0.0390625V37.2638H31.8974V5.58447ZM26.8949 10.5752H5.05941V32.2317H26.8949V10.5752Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.281 6.89178C121.259 7.35212 120.295 7.9166 119.402 8.5717L141.737 30.9068C142.392 30.0134 142.957 29.0493 143.417 28.0282L122.281 6.89178ZM144.816 21.0477C144.597 12.5556 137.753 5.71168 129.261 5.49268L144.816 21.0477ZM113.907 15.7683C114.293 14.7588 114.778 13.7985 115.35 12.8992L137.409 34.9589C136.51 35.5312 135.55 36.0161 134.54 36.4016L113.907 15.7683ZM127.115 37.3556L112.953 23.1938C113.753 30.6405 119.668 36.5557 127.115 37.3556Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.867 28.2504L225.867 37.1191C229.989 37.1191 234.071 36.3072 237.88 34.7297C241.688 33.1522 245.148 30.84 248.063 27.9252C250.978 25.0104 253.29 21.55 254.868 17.7416C256.445 13.9332 257.257 9.85142 257.257 5.72925H248.405C248.404 18.1675 238.321 28.2504 225.882 28.2504C225.877 28.2504 225.872 28.2504 225.867 28.2504Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.305 6.66824L338.305 11.1454L363.177 11.1454L363.177 36.1802L367.654 36.1802L367.654 11.1454L367.655 11.1454L367.655 6.66824L338.305 6.66824Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.099 27.6363C490.538 26.4807 490.852 25.2881 491.039 24.0799L456.153 24.0799C456.34 25.2881 456.654 26.4806 457.093 27.6363L490.099 27.6363ZM461.465 34.182C468.264 40.6192 478.928 40.6192 485.727 34.182L461.465 34.182ZM489.711 14.1368C490.203 15.2357 490.577 16.3745 490.833 17.5342L456.359 17.5342C456.615 16.3745 456.989 15.2357 457.481 14.1368L489.711 14.1368ZM462.541 7.59113L484.651 7.59115C478.212 2.40671 468.98 2.4067 462.541 7.59113Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M611.397 5.58447H579.539V37.2638H611.397V5.58447ZM606.395 10.5752H584.559V32.2317H606.395V10.5752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoodleGroupWhite);
export default __webpack_public_path__ + "static/media/doodleGroupWhite.d56732105449ab80cbf7c315b3e796b3.svg";
export { ForwardRef as ReactComponent };